import { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Styles from './Accordion.module.scss';

import PlusCircle from '@hiredigital/ui/Icon/icons/plus-circle.inline.svg';
import MinusCircle from '@hiredigital/ui/Icon/icons/minus-circle.inline.svg';

const PanelHead = ({ title, children, isExpanded, className, hasExpandIcon = true, ...props }) => {
  const Icon = isExpanded ? MinusCircle : PlusCircle;
  return (
    <div className={classNames(Styles.panelHead, className)} {...props}>
      {hasExpandIcon && <Icon className={Styles.iconToggle} />}
      {children ? (
        <Fragment>{children}</Fragment>
      ) : (
        <Fragment>
          <h3 className={Styles.title}>{title}</h3>
        </Fragment>
      )}
    </div>
  );
};

const PanelBody = ({ content = '', children, isExpanded, className, ...props }) => (
  <div
    className={classNames(Styles.panelBody, { [Styles.collapse]: !isExpanded }, className)}
    {...props}>
    {children ? (
      children
    ) : (
      <span
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    )}
  </div>
);

const Panel = ({ title, content, hasExpandIcon }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggle = () => setIsExpanded(!isExpanded);

  return (
    <div className={Styles.panel}>
      <PanelHead
        title={title}
        onClick={toggle}
        isExpanded={isExpanded}
        hasExpandIcon={hasExpandIcon}
      />
      <PanelBody content={content} isExpanded={isExpanded} />
    </div>
  );
};

const Accordion = ({
  className,
  data = [],
  defaultExpand = false,
  noBorder = false,
  hasExpandIcon = true,
  children,
  ...props
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpand);
  const toggle = () => setIsExpanded(!isExpanded);

  return (
    <div
      className={classNames(Styles.container, noBorder && Styles.noBorder, className)}
      {...props}>
      {children ? (
        <Fragment>{children(isExpanded, toggle)}</Fragment>
      ) : (
        <Fragment>
          {data?.map(({ title, content }, idx) => (
            <Panel key={idx} title={title} content={content} hasExpandIcon={hasExpandIcon} />
          ))}
        </Fragment>
      )}
    </div>
  );
};

Accordion.propTypes = {
  className: PropTypes.string,
};

Accordion.Head = PanelHead;
Accordion.Body = PanelBody;

export default Accordion;
